import { render } from "./UserLoginView.vue?vue&type=template&id=3cc4a97c"
import script from "./UserLoginView.vue?vue&type=script&lang=js"
export * from "./UserLoginView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__